import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { ChannelCategory } from 'icreate/common/models/channel-category';

@Component({
    selector: 'app-channel-select-input',
    templateUrl: './channel-select-input.component.html',
    styleUrls: ['./channel-select-input.component.scss'],
    standalone: false,
})
export class ChannelSelectInputComponent implements OnInit, OnChanges {
    @ViewChild('container') container: ElementRef;

    @Input() name: string;
    @Input() label: string;
    @Input() categoryList: ChannelCategory[];
    @Input() itemList: any[];
    @Input() value = '';
    @Input() dark: boolean = false;
    @Input() height: number = 0;
    @Input() isDisabled: boolean = false;
    @Input() thickBorder: boolean = true;

    inputValue = '';
    isShowSelect = false;

    @Output() inputChange = new EventEmitter();

    @HostListener('document:click', ['$event']) clickOut(event: MouseEvent) {
        if (!this.container?.nativeElement.contains(event.target) && this.isShowSelect) {
            this.isShowSelect = false;
        }
    }

    ngOnInit() {
        if (this.categoryList) {
            let exist = this.categoryList.find(category => category.id == this.value);
            if (exist) {
                this.inputValue = exist.category;
            }
        } else {
            this.inputValue = this.value ? this.value : '';
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.itemList || changes.value) {
            this.inputValue = this.value;
        }
    }

    selectValue(event: MouseEvent, value: ChannelCategory | string) {
        event.preventDefault();
        if (this.isDisabled) return;
        if (typeof value !== 'string' && typeof value !== 'number') {
            this.inputValue = value.category;
            this.inputChange.emit({ name: this.name, value: value.id });
        } else {
            this.inputValue = value;
            this.inputChange.emit({ name: this.name, value: value });
        }
        this.isShowSelect = false;
    }

    openSelect() {
        if (this.isDisabled) return;
        this.isShowSelect = this.isShowSelect ? false : true;
    }
}
